import $ from "jquery"
import jBox from 'jbox';

$(function () {

	const $media = $('.site-media')
	if ($media.length) {

		const $breadcrumbItems = $media.find('.mediaImages li.breadcrumbItem');
		$breadcrumbItems.each(function () {
			const $breadcrumbItem = $(this);
			$breadcrumbItem.on('click', '> a', function () {
				$breadcrumbItem.find('.breadcrumbSiblings').toggleClass('visible');
			});

			$(document).on('click', function (event) {
				if ($(event.target) !== $breadcrumbItem && !$(event.target).parents().filter($breadcrumbItem).length) {
					$breadcrumbItem.find('.breadcrumbSiblings').removeClass('visible');
				}
			})

		});

		$media.on('click', '.mediaImages .folders .post', function (ev) {
			window.location = $(this).data('urlpath');
			ev.preventDefault();
			ev.stopPropagation();
		})

		const $mediaPhotos = $media.find('.mediaImages .posts.photos');
		if ($mediaPhotos.length) {
			$mediaPhotos.find('.post').on('click', function (ev) {
				ev.preventDefault();
				ev.stopPropagation();
			});
			let jbox = null;
			$mediaPhotos.find('.postItems').on('postAjaxLoadStart', function () {
				if (jbox) {
					jbox.destroy();
					$mediaPhotos.find('.postItems > .post').removeData('jBox-image-gallery');
				}
				$mediaPhotos.find('.postItems > .post').addClass('disableClick');
			})
			$mediaPhotos.find('.postItems').on('postAjaxLoaded', function () {
				setTimeout(function () {
					jbox = new jBox('Image', {
						src: 'data-urlpath',
						trigger: 'click',
						gallery: 'data-gallery',
						attach: '.post',
					});
				}, 1000)

				$mediaPhotos.find('.postItems > .post').removeClass('disableClick');
			});

			$mediaPhotos.find('.postItems').trigger('postLoadAjax');
		}

		const $videoPlaylists = $media.find('.mediaVideos .playlists');
		const $videos = $media.find('.mediaVideos .videos');

		$videoPlaylists.on('click', 'a', function () {
			const $col = $(this);
			const playlistId = $col.data('playlistid');
			const $playlistVideos = $videos.find('.playlistVideos[data-playlistid="' + playlistId + '"]');

			const $activePlaylistVideos = $videos.find('.playlistVideos.active');
			if ($activePlaylistVideos.length > 0) {
				$activePlaylistVideos.find('.postItems').trigger('postCloseAll');
			}

			$col.siblings().removeClass('active');
			$col.addClass('active');

			$playlistVideos.siblings().removeClass('active');
			$playlistVideos.addClass('active');
			$playlistVideos.find('.postItems').trigger('postCloseAll');

			$([document.documentElement, document.body]).animate({
				scrollTop: $videoPlaylists.offset().top,
			}, 500);
		});

		$videos.find('.post').each(function () {

		});
		$videos.on('click', '.post', function () {
			function onPlayerReady (event) {
				event.target.playVideo();
			}

			const $item = $(this);
			const videoId = $item.data('id');
			let jbox = null;
			if ($item.data('jBox-video-modal')) {
				jbox = $item.data('jBox-video-modal');
			} else {
				jbox = new jBox('Modal', {
					closeButton: 'title',
					repositionOnOpen: true,
					onClose: function () {
						const player = $item.data('ytPlayer');
						if (player) {
							player.stopVideo();
						}
					},
				});
				jbox.setContent('<div id="player_' + videoId + '"></div>');
				jbox.setTitle($item.find('.titleWrapper').text());
				$item.data('jBox-video-modal', jbox);
			}

			const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

			//Calculate player width and height to fit in window
			let playerWidth = windowWidth * 0.8;
			let playerHeight = playerWidth * 9 / 16;
			if (playerHeight > windowHeight * 0.8) {
				playerHeight = windowHeight * 0.8;
				playerWidth = playerHeight * 16 / 9;
			}

			if ($item.data('ytPlayer')) {
				$item.data('ytPlayer').playVideo();
				jbox.open();
			} else {
				$item.data('ytPlayer', new YT.Player('player_' + videoId, {
					width: playerWidth,
					height: playerHeight,
					videoId: videoId,
					playerVars: { 'playsinline': 1 },
					events: {
						'onReady': function (event) {
							event.target.playVideo();
							jbox.open();
						},
					},
				}));
			}
		});

		$videos.on('postOpened', '.post', function () {
			const $item = $(this);
			const videoId = $item.data('id');

			if ($item.data('ytPlayer')) {
				$item.data('ytPlayer').playVideo();
			} else {
				$item.find('.openContainer').html('<div id="player_' + videoId + '"></div>');

				const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				console.log('windowWidth', windowWidth);
				$item.data('ytPlayer', new YT.Player('player_' + videoId, {
					width: windowWidth - 100,
					videoId: videoId,
					playerVars: { 'playsinline': 1 },
					events: { 'onReady': onPlayerReady },
				}));
			}

			function onPlayerReady (event) {
				event.target.playVideo();
			}
		});

		$videos.on('postClosed', '.post', function () {
			const player = $(this).data('ytPlayer');
			if (player) {
				player.stopVideo();
			}
		});

	}
});
